import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider, useSettings } from "@/context/SettingsContext";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import GA4 from "@/components/site/GA4";

import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/Layout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductEditor from "@/pages/admin/AdminProductEditor";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";

const PublicShell = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

const GlobalAnalytics = () => {
  const { settings } = useSettings();
  return <GA4 measurementId={settings?.ga_measurement_id} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
            <GlobalAnalytics />
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="products/:id" element={<AdminProductEditor />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="blog/:id" element={<AdminBlogEditor />} />
                <Route path="contacts" element={<AdminContacts />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="newsletter" element={<AdminNewsletter />} />
              </Route>

              <Route path="/" element={<PublicShell><Home /></PublicShell>} />
              <Route path="/products" element={<PublicShell><Products /></PublicShell>} />
              <Route path="/products/:slug" element={<PublicShell><ProductDetail /></PublicShell>} />
              <Route path="/services" element={<PublicShell><Services /></PublicShell>} />
              <Route path="/about" element={<PublicShell><About /></PublicShell>} />
              <Route path="/blog" element={<PublicShell><Blog /></PublicShell>} />
              <Route path="/blog/:slug" element={<PublicShell><BlogDetail /></PublicShell>} />
              <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
            </Routes>
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
